import {Component, ContentChildren, QueryList} from "@angular/core";
import {AddRowActionComponent} from "./add-row-action.component";

@Component({
    selector: "wbo-edit-grid-add-row-actions",
    templateUrl: "./edit-grid-add-row-actions.component.html"
})
export class EditGridAddRowActionsComponent {

    @ContentChildren(AddRowActionComponent) public actions: QueryList<AddRowActionComponent>;

    constructor() {
    }
}
